"use client"

import { cn } from "@/lib/utils"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs" // Import Tabs components
import { useEffect, useState } from "react" // Import useEffect and useState for handling tab value

export function HomeDiscoveryNavDesktop() {
  const pathname = usePathname()

  // Don't render anything if not on a /home/* path
  if (!pathname?.startsWith("/home")) return null

  return (
    <>
      {/* Desktop Navigation (hidden on mobile) */}
      <div className="hidden sm:flex flex-row space-x-4">
        <Link
          href="/home"
          className={cn(
            "text-sm text-muted-foreground hover:text-gray-700 dark:text-gray-400 dark:hover:text-white",
            pathname === "/home" && "font-medium text-primary dark:text-white" // Added font-medium for active state
          )}
        >
          For you
        </Link>

        <Link
          href="/home/subscriptions"
          className={cn(
            "text-sm text-muted-foreground hover:text-gray-700 dark:text-gray-400 dark:hover:text-white",
            pathname === "/home/subscriptions" &&
              "font-medium text-primary dark:text-white" // Added font-medium for active state
          )}
        >
          Your subscriptions
        </Link>
        {/* Add more desktop links here if needed */}
      </div>
    </>
  )
}

export function HomeDiscoveryNavMobile() {
  const pathname = usePathname()
  // State to manage the active tab value based on pathname
  const [activeTab, setActiveTab] = useState("home")

  // Update the active tab when the pathname changes
  useEffect(() => {
    if (pathname === "/home/subscriptions") {
      setActiveTab("subscriptions")
    } else if (pathname === "/home") {
      setActiveTab("home")
    }
    // If you add more paths/tabs later, add more else if conditions here
    // You might want a more robust way to map path segments to tab values
    // if the structure becomes more complex.
  }, [pathname])

  // Don't render anything if not on a /home/* path
  if (!pathname?.startsWith("/home")) return null

  return (
    <>
      {/* Mobile Navigation using Tabs (visible only on mobile) */}
      {/* Use 'block' or 'flex' depending on desired layout, hidden on sm and up */}
      <div className="mt-8 block sm:hidden w-full px-8 pb-2">
        {" "}
        {/* Added padding for mobile */}
        <Tabs value={activeTab} className="w-full">
          {/* Use grid layout to make tabs fill width evenly */}
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="home" asChild>
              {/* Use asChild to render the Link component directly */}
              <Link href="/home">For you</Link>
            </TabsTrigger>
            <TabsTrigger value="subscriptions" asChild>
              <Link href="/home/subscriptions">Your subscriptions</Link>
            </TabsTrigger>
            {/* Add more TabsTrigger components here if needed */}
          </TabsList>
          {/* No TabsContent needed as we are just using Tabs for navigation */}
        </Tabs>
      </div>
    </>
  )
}
